@let devices = devices$ | async;
<span class="list-title">Registrierte Geräte</span>
<mat-list class="scrolled-output" [attr.data-testid]="testIds.deviceList">
  @for (device of devices; track device['device_id']) {
    <app-device-card
      [deviceId]="device['device_id']"
      [displayName]="device['display_name'] ?? 'Gerät ' + ($index + 1)"
      [lastSeenIp]="device['last_seen_ip'] ?? ''"
      [lastSeenTs]="device['last_seen_ts'] ?? 0"
      [attr.data-testid]="testIds.deviceListCard"></app-device-card>
  }
</mat-list>
